const routes = [
  {
    path: 'dialog',
    name: 'dialog',
    component: () => import(/* webpackChunkName: "dialog" */ '@/modules/dialog/index.vue')
  },
];

export default routes;